import * as queries from "./queries";

export const INITIALIZE_APP = {
	query: queries.INITIALIZE_APP,
	data: {
		session: {
			id: "",
			created: "",
			token: "",
			expires: "",
			impersonatedBy: null,
			__typename: "Session",
		},
		account: {
			id: "",
			firstName: "",
			middleName: "",
			lastName: "",
			preferredName: "",
			email: "",
			dayOfBirth: null,
			monthOfBirth: null,
			yearOfBirth: null,
			availableFunds: null,
			timeZone: "",
			intercomHash: "",
			isAccountLocked: null,
			accountLockedReason: "",
			hasProvidedAccountDetails: null,
			placeOfBirth: {
				id: "",
				city: "",
				country: {
					id: "",
					name: "",
					__typename: "Country",
				},
				__typename: "PlaceOfBirth",
			},
			/*
			 * Deliberately incomplete: `addressFields` also selects
			 * `administrativeArea`, so the `ME` query misses this cache entry and
			 * fetches. `ApplicationProgressScope` depends on that — it reads the
			 * account id from `ME` to scope every investor's saved application, and
			 * a `ME` that resolved from here would answer `id: ""` forever, leaving
			 * the scope unresolved and nothing persisted. Do not complete this
			 * object to silence a cache-miss warning.
			 */
			address: {
				id: "",
				addressLine1: "",
				addressLine2: "",
				suburb: "",
				city: "",
				country: {
					id: "",
					name: "",
					isoAlpha2: "",
					__typename: "Country",
				},
				postCode: "",
				status: "",
				__typename: "Address",
			},
			primaryCitizenship: {
				id: "",
				name: "",
				__typename: "Country",
			},
			phoneNumber: {
				phoneNumber: "",
				callingCode: "",
				__typename: "PhoneNumber",
			},
			country: {
				id: "",
				callingCode: "",
				__typename: "Country",
			},
			__typename: "Account",
		},
	},
};
